import React, { useEffect } from 'react';
import { ApplicationStatus } from 'types';

interface OpportunitiesCardCurrentStatusProps {
	currentStatus: ApplicationStatus;
}
const OpportunitiesCardCurrentStatus: React.FC<OpportunitiesCardCurrentStatusProps> = ({ currentStatus }) => {
	const [applicationCardState, setApplicationCardState] = React.useState<string>('');

	useEffect(() => {
		if (!currentStatus) {
			return;
		}
		if (
			currentStatus &&
			[ApplicationStatus.OPENED_BY_EMPLOYER, ApplicationStatus.OPENED_BY_ADMIN].includes(currentStatus)
		) {
			setApplicationCardState('Waiting');
		} else if (currentStatus === ApplicationStatus.SHORTLISTED) {
			setApplicationCardState('Shortlisted');
		} else if (currentStatus && [ApplicationStatus.WAITING_FOR_RECRUITER_ACTION].includes(currentStatus)) {
			setApplicationCardState('Waiting For Recruiter Action');
		} else if (
			currentStatus &&
			[ApplicationStatus.PENDING_FOR_ASSIGNMENT_SUBMISSION_APPROVAL].includes(currentStatus)
		) {
			setApplicationCardState('Waiting For Assignment Submission Approval');
		} else if (currentStatus && [ApplicationStatus.PENDING_FOR_OFFER_LETTER_APPROVAL].includes(currentStatus)) {
			setApplicationCardState('Waiting For Offer Letter Approval');
		} else if (currentStatus && [ApplicationStatus.QUALIFIED_ALL_ROUNDS].includes(currentStatus)) {
			setApplicationCardState('Qualified');
		} else if (currentStatus === ApplicationStatus.INTERVIEW_SCHEDULED) {
			setApplicationCardState('Interview Round In Progress');
		} else if (currentStatus === ApplicationStatus.ASSIGNMENT_IN_PROGRESS) {
			setApplicationCardState('Assignment Round In Progress');
		} else if (currentStatus === ApplicationStatus.JOBSEEKER_OPTED_OUT) {
			setApplicationCardState('Jobseeker Opted Out');
		} else if (currentStatus === ApplicationStatus.OFFER_ROLLED_OUT) {
			setApplicationCardState('Offered');
		} else if (currentStatus === ApplicationStatus.PENDING_FOR_OPT_OUT_APPROVAL) {
			setApplicationCardState('Waiting For Opt Out Approval');
		} else if (currentStatus === ApplicationStatus.VERBALLY_PLACED) {
			setApplicationCardState('Placed');
		} else if (currentStatus === ApplicationStatus.PLACED) {
			setApplicationCardState('Placed');
		} else if (currentStatus === ApplicationStatus.CHANGED_OFFER_TERMS) {
			setApplicationCardState('Changed Offer Terms');
		} else if (
			currentStatus &&
			[
				ApplicationStatus.CLOSED_BY_ADMIN,
				ApplicationStatus.CLOSED_BY_RECRUITER,
				ApplicationStatus.EXPIRED,
				ApplicationStatus.OFFER_REVOKED,
				ApplicationStatus.PLACED_ELSEWHERE,
				ApplicationStatus.OFFER_REJECTED,
			].includes(currentStatus)
		) {
			const label =
				[
					ApplicationStatus.CLOSED_BY_ADMIN,
					ApplicationStatus.CLOSED_BY_RECRUITER,
					ApplicationStatus.EXPIRED,
				].includes(currentStatus) ? 'Expired' : 'Closed';
			setApplicationCardState(label);
		} else if (currentStatus && [ApplicationStatus.REJECTED].includes(currentStatus)) {
			setApplicationCardState('Rejected');
		} else {
			setApplicationCardState('Applied');
		}
	}, [currentStatus]);

	return (
		<div className="flex md:flex-end w-fit md:justify-end bg-[#DEF7EC] rounded-[6px] px-[10px] py-[2px]">
			<div className="text-[#03543F] font-inter text-[12px] font-[500] leading-[18px]">{applicationCardState}</div>
		</div>
	);
};

export default OpportunitiesCardCurrentStatus;
